import {Component} from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { setTranslations, addAllBrands, addAllLacks } from './redux/actions';
import cookie from 'js-cookie';
import merge from 'lodash.merge';
import moment from 'moment';

import config from './config';
import { getTranslations, getPartTypes, getStyleValue, writeLog, getLacks } from './components/Helpers/Helpers';

import NotFound from './components/NotFound/NotFound';
import Overview from './components/Overview/Overview';

import MainLayout from './components/MainLayout/MainLayout';
import TopMenu from './components/TopMenu/TopMenu';
import Home from './components/Home/Home';
import Log from './components/Log/Log';
import Inspection from './components/Inspection/Inspection';

import ArrowBack from '@mui/icons-material/ArrowBack';
import Check from '@mui/icons-material/Check';
import ErrorOutline from '@mui/icons-material/ErrorOutline';
import { IconButton } from '@mui/material';

class App extends Component {
	constructor(props) {
		super(props);

		this.initialState = {
			data: {
				all_fetched: cookie.get('all_fetched') || null,
				is_auth: cookie.get('auth'),
			},
		};

		// Clone the initialState and set it as current state
		this.state = JSON.parse(JSON.stringify(this.initialState));
	}
	componentDidMount() {
		if ((!this.props.t || Object.keys(this.props.t).length === 0)
			&& this.state.data.is_auth) {
			getTranslations()
				.then(translations => {
					this.props.dispatch(setTranslations(translations));
					this.updateAppState({ t: translations });
				})
				.catch(error => {
					writeLog('Could not load translations', 'error');
					console.error(error);
				});
		}
		getPartTypes()
			.then(partTypes => {
				this.props.dispatch(addAllBrands(partTypes));
			})
			.catch(error => {
				writeLog('Could not load part types', 'error');
				console.error(error);
			});
		getLacks()
			.then(lacks => {
				this.props.dispatch(addAllLacks(lacks));
			})
			.catch(error => {
				writeLog('Could not load lacks', 'error');
				console.error(error);
			});
	}
	updateAppState(data, cb) {
		this.setState({data: merge({}, this.state.data, data)}, cb);
	}
	getAppState(property) {
		return this.state.data[property];
	}
	clearAllState() {
		const msgChan = new MessageChannel();
		if (navigator.serviceWorker && navigator.serviceWorker.controller) {
			navigator.serviceWorker.controller.postMessage('clean-all-cache', [msgChan.port2]);
		}
		this.setState(this.initialState);
	}
	navigateBack(route) {
		route.history.goBack();
	}
	getOfflineSubtitle() {
		const errorIcon = <ErrorOutline style={{width: getStyleValue('font-size-small'), verticalAlign: 'middle'}} color="inherit" />;
		const done = <Check style={{width: getStyleValue('font-size-small'), verticalAlign: 'middle'}} color="inherit" />;
		let topNavSubtitle = <span>{errorIcon}{this.props.t.offline_unavailable}</span>;
		if (this.state.data.all_fetched) {
			const formattedDate = moment(this.state.data.all_fetched).format('DD MMMM HH:mm');
			topNavSubtitle = <span>{done} {this.props.t.offline_available} ({formattedDate})</span>;
		}
		return topNavSubtitle;
	}
	render() {
		const AuthRoute = ({component: Component, ...rest}) => (
			<Route {...rest} render={(props) => {
				if (this.state.data.is_auth) {
					return <Component {...props}/>;
				} else {
					return <Redirect to={{pathname: '/login'}} />;
				}
			}} />
		);

		const arrowBackIcon = (route) => (
			<IconButton
				onClick={() => this.navigateBack(route)}
				style={{ marginRight: 8 }}
				color="inherit"
				size="large">
				<ArrowBack  />
			</IconButton>
		);

		return (
			<Router>
				<Switch>
					<AuthRoute exact path="/" component={(route) => {
						return (
							<MainLayout
								{...route}
								TopNav={{
									title: `${config.app_name}: ${this.props.t.planned_inspection}`,
									subtitle: this.getOfflineSubtitle(),
									showMenuIconButton: true,
									iconElementRight: <TopMenu {...route} t={this.props.t} updateAppState={this.updateAppState.bind(this)} clearAllState={this.clearAllState.bind(this)} />,
								}}
							>
								<Overview
									{...route}
									updateAppState={this.updateAppState.bind(this)}
									getAppState={this.getAppState.bind(this)}
								/>
							</MainLayout>
						);
					}} />

					<AuthRoute exact path="/inspection/:id/:title/:group" component={(route) => {
						return (
							<MainLayout
								{...route}
								TopNav={{
									title: `${config.app_name}: ${this.props.t.inspection} ${route.match.params.title}`,
									subtitle: this.getOfflineSubtitle(),
									showMenuIconButton: true,
									iconElementLeft: arrowBackIcon(route),
									iconElementRight: <TopMenu {...route} t={this.props.t} updateAppState={this.updateAppState.bind(this)} clearAllState={this.clearAllState.bind(this)} />,
								}}
							>
								<Inspection
									{...route}
									updateAppState={this.updateAppState.bind(this)}
									getAppState={this.getAppState.bind(this)}
								/>
							</MainLayout>
						);
					}} />

					<Route exact path="/log" component={(route) => {
						return (
							<MainLayout
								{...route}
								TopNav={{
									title: `${config.app_name}: Log`,
									subtitle: '',
									showMenuIconButton: true,
									iconElementRight: <TopMenu {...route} t={this.props.t} updateAppState={this.updateAppState.bind(this)} clearAllState={this.clearAllState.bind(this)} />,
								}}
							>
								<Log {...route} updateAppState={this.updateAppState.bind(this)} />
							</MainLayout>
						);
					}} />

					<Route exact path="/login" component={(route) => {
						return (<MainLayout {...route}
							TopNav={{
								subtitle: ' ',
							}}>
							<Home
								{...route}
								t={ this.state.data.t }
								updateAppState={this.updateAppState.bind(this)}
							/>
						</MainLayout>);
					}} />

					<Route component={(route) => {
						return (<MainLayout {...route}
							TopNav={{
								title: this.props.t.page_not_found,
								subtitle: ' ',
								showMenuIconButton: true,
								iconElementLeft: arrowBackIcon(route),
							}}>
							<NotFound t={ this.props.t } {...route} />
						</MainLayout>);
					}} />
				</Switch>
			</Router>
		);
	}
}

function mapStateToProps (state) {
	const { t } = state.store;
	return { t };
}
export default connect(mapStateToProps)(App);
